import { render, staticRenderFns } from "./FcMenu.vue?vue&type=template&id=589ab5b6&"
import script from "./FcMenu.vue?vue&type=script&lang=js&"
export * from "./FcMenu.vue?vue&type=script&lang=js&"
import style0 from "./FcMenu.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/fiksucity/city-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('589ab5b6')) {
      api.createRecord('589ab5b6', component.options)
    } else {
      api.reload('589ab5b6', component.options)
    }
    module.hot.accept("./FcMenu.vue?vue&type=template&id=589ab5b6&", function () {
      api.rerender('589ab5b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/lib/FcMenu.vue"
export default component.exports